import React from 'react';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { GlobalViewTaxForm } from './global-viewtaxform';
import { ViewTaxFormPropTypes } from '../../shapes';

export const MZTaxViewTaxForm = props => (
  <GlobalViewTaxForm
    {...props}
    countryCode={Constants.CountryCode.MZ}
    showTaxCert={false}
  />
);

MZTaxViewTaxForm.propTypes = ViewTaxFormPropTypes;
